import {getTestProps} from '@benchling/js-test-utils';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import SampleTypesDictionary from 'sample-types/SampleTypesDictionary';
import {Header1} from 'ui-library/Headers';

export default function SampleTypesListing(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Sample Types');
  }, []);

  return (
    <div className="settingsPage" {...getTestProps({component: 'SampleTypesListing', element: 'root'})}>
      <div className="settingsPage-contentWrapper">
        <Header1>Sample Types</Header1>
        <SampleTypesDictionary />
      </div>
    </div>
  );
}
